export default __webpack_public_path__ + "static/media/shader.00bfe510.vert";